import { Box, Flex } from '@workwhile/ui'
import React from 'react'
import { useI9HubContextValue } from '../../context/I9HubProvider'
import { GroupByAttributesSelector } from '../GroupByAttributesSelector'
import type { ReverificationGroupBy } from '../../context/i9HubRows'
import {
  ExpirationWindowUrlFilter,
  type ExpirationDaysUrl,
} from './ExpirationWindowUrlFilter'
import { I9HubWorkerUrlFilters } from './I9HubWorkerUrlFilters'

const REVERIFICATION_GROUP_BY_OPTIONS: {
  label: string
  value: ReverificationGroupBy
}[] = [
  { label: '30 / 60 / 90-day buckets', value: 'expiration_bucket' },
  { label: 'State', value: 'state' },
  { label: 'Market', value: 'market' },
]

export function I9ReverificationHubFilters() {
  const {
    state: {
      reverification: {
        stateSelectOptions,
        marketSelectOptions,
        filters,
        expirationFilterDays,
        groupBy,
      },
    },
    actions: { setReverificationQuery },
  } = useI9HubContextValue()

  return (
    <Flex flexDirection="row" flexWrap="wrap" gap={2} alignItems="flex-start">
      <Flex flexDirection="row" flexWrap="wrap" gap={2} alignItems="center">
        <ExpirationWindowUrlFilter
          value={expirationFilterDays}
          onChange={(days) =>
            setReverificationQuery({
              revExpirationDays: String(days) as ExpirationDaysUrl,
            })
          }
        />
        <I9HubWorkerUrlFilters
          stateSelectOptions={stateSelectOptions}
          marketSelectOptions={marketSelectOptions}
          filters={filters}
          onFiltersChange={(patch) =>
            setReverificationQuery({
              ...(patch.state !== undefined ? { revState: patch.state } : {}),
              ...(patch.market !== undefined
                ? { revMarket: patch.market }
                : {}),
              ...(patch.workerId !== undefined
                ? { revWorkerId: patch.workerId }
                : {}),
              ...(patch.workerSearch !== undefined
                ? { revWorkerSearch: patch.workerSearch }
                : {}),
            })
          }
        />
      </Flex>
      <Box ml={4}>
        <GroupByAttributesSelector
          label="Group by"
          filterKey="rev-group-by"
          options={REVERIFICATION_GROUP_BY_OPTIONS}
          value={groupBy}
          onChange={(next) =>
            setReverificationQuery({
              revGroupBy: next as ReverificationGroupBy,
            })
          }
        />
      </Box>
    </Flex>
  )
}
